
import React from "react";
import { useNavigate } from "react-router-dom";
import useNotifications from "../../hooks/useNotifications";

export default function NotificationDropdown({ open, onClose }) {
  const notifications = useNotifications();
  const navigate = useNavigate();

  if (!open) return null;

  // Handler for notification click
  const handleNotificationClick = (notif) => {
    if (notif.type === "invoice_due") {
      // Extract invoice id from notif.id (format: due-*-<invoiceId>)
      const parts = notif.id.split("-");
      const invoiceId = parts[2];
      if (invoiceId) {
        navigate(`/invoices/${invoiceId}`);
        onClose();
      }
    } else if (notif.type === "subscription_end") {
      navigate("/subscription");
      onClose();
    }
  };

  return (
    <div className="absolute right-0 mt-2 w-80 bg-white rounded-md shadow-lg z-50 border p-2 max-h-96 overflow-y-auto">
      <div className="font-bold text-lg mb-2">Notifications</div>
      {notifications.length === 0 ? (
        <div className="text-gray-500 text-sm">No notifications</div>
      ) : (
        notifications.map((notif) => (
          <div
            key={notif.id}
            className="mb-2 p-2 rounded hover:bg-blue-50 cursor-pointer text-sm border-b last:border-b-0"
            onClick={() => handleNotificationClick(notif)}
          >
            {notif.message}
          </div>
        ))
      )}
      <button onClick={onClose} className="mt-2 w-full py-1 bg-blue-500 text-white rounded hover:bg-blue-600">Close</button>
    </div>
  );
}
